import { ChevronRightIcon } from "@heroicons/react/outline";
import { Workflow, Page, WorkflowAutomationItem } from "./interface";
import { useTranslation } from "react-i18next";
import { getFinalBreadcrumbLabel } from "./reviewCtaUtils";

interface Props {
  workflow?: Workflow;
  currentPage: Page;
  automationItem?: WorkflowAutomationItem;
}

function Breadcrumbs(props: Props) {
  const { t } = useTranslation();
  const { workflow, currentPage, automationItem } = props;

  if (!workflow)
    return null;

  const isConfigure = currentPage === "DATA" || currentPage === "RECIPIENTS";
  const isGenerate = currentPage === "AUTOMATION";
  const isReview = currentPage === "PREVIEW";
  const finalLabel = getFinalBreadcrumbLabel(workflow, currentPage, automationItem);

  return (
    <div className="flex items-center gap-1 text-xs">
      <div className={`font-semibold font-gilroy ${isConfigure ? "text-blue" : "text-gray-400"}`}>
        {t("Configure")}
      </div>
      <ChevronRightIcon className="w-3 h-3 text-gray-400" />
      <div className={`font-semibold font-gilroy ${isGenerate ? "text-blue" : "text-gray-400"}`}>
        {t("Generate Documents")}
      </div>
      <ChevronRightIcon className="w-3 h-3 text-gray-400" />
      <div className={`font-semibold font-gilroy ${isReview ? "text-blue" : "text-gray-400"}`}>
        {t(finalLabel)}
      </div>
    </div>
  );
}

export default Breadcrumbs;
